import styled from 'styled-components';

export const TopBar = styled.div`
  padding: 24px 120px 0;

  @media (min-width: 801px) and (max-width: 1200px) {
    padding: 24px 60px 0;
  }
  @media (max-width: 800px) {
    padding: 16px 16px 0;
  }
`;

export const BackButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.gulfStream};
  font-size: 14px;
  ${({ theme }) => theme.fonts.regular};
  padding: 0;

  &:hover {
    opacity: 0.75;
  }
`;

export const SerieTitleWrapper = styled.div`
  text-align: center;
  padding: 40px 0 20px;
`;

export const SerieTitle = styled.h2`
  font-size: 22px;
  ${({ theme }) => theme.fonts.semiBold};
  color: ${({ theme }) => theme.colors.shaft};
  letter-spacing: 0.08em;
  text-transform: uppercase;
  margin: 0 0 12px;
`;

export const SerieTitleAccent = styled.div`
  width: 48px;
  height: 2px;
  background: ${({ theme }) => theme.colors.gulfStream};
  margin: 0 auto;
`;

export const SerieGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  padding: 24px 120px 56px;

  @media (min-width: 801px) and (max-width: 1200px) {
    padding: 24px 60px 56px;
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 800px) {
    padding: 24px 16px 56px;
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;
